const pageNameKey = "otaFirmwareInstallModal";

export const otaFirmwareInstallModalEn = {
  [pageNameKey]: {
    installingFirmwareText: "Installing Firmware",
    installFirmwareOnDeviceText: "Installing firmware on device",
    descriptionText:
      "This may take a few minutes. Please do not close this window while the firmware installation is in progress.",
    firmwareText: "Firmware",
    versionText: "Version",
    digestText: "Digest",
    sizeText: "Size",
    progressText: "Progress:",
    firmwareInstallationCompleted: "Firmware installation completed",
    firmwareInstallationFailed: "Firmware installation failed",
    installationTimeoutFailed: "Installation timeout. Please check device.",
  },
};

export const otaFirmwareInstallModalPtBr = {
  [pageNameKey]: {
    installingFirmwareText: "Instalando firmware",
    installFirmwareOnDeviceText: "Instalando firmware no dispositivo",
    descriptionText:
      "Isso pode levar alguns minutos. Não feche esta janela enquanto a instalação do firmware estiver em andamento.",
    firmwareText: "Firmware",
    versionText: "Versão",
    digestText: "Hash",
    sizeText: "Tamanho",
    progressText: "Progresso:",
    firmwareInstallationCompleted: "Instalação do firmware concluída",
    firmwareInstallationFailed: "Falha na instalação do firmware",
    installationTimeoutFailed:
      "Tempo limite de instalação. Verifique o dispositivo.",
  },
};

export const otaFirmwareInstallModalDe = {
  [pageNameKey]: {
    installingFirmwareText: "Firmware wird installiert",
    installFirmwareOnDeviceText: "Firmware wird auf dem Gerät installiert",
    descriptionText:
      "Dies kann einige Minuten dauern. Bitte schließen Sie dieses Fenster nicht, während die Firmware installiert wird.",
    firmwareText: "Firmware",
    versionText: "Version",
    digestText: "Prüfsumme",
    sizeText: "Größe",
    progressText: "Fortschritt:",
    firmwareInstallationCompleted: "Firmware-Installation abgeschlossen",
    firmwareInstallationFailed: "Firmware-Installation fehlgeschlagen",
    installationTimeoutFailed:
      "Zeitüberschreitung bei der Installation. Bitte überprüfen Sie das Gerät.",
  },
};

export const otaFirmwareInstallModalZhHans = {
  [pageNameKey]: {
    installingFirmwareText: "正在安装固件",
    installFirmwareOnDeviceText: "正在设备上安装固件",
    descriptionText: "这可能需要几分钟。固件安装过程中，请不要关闭此窗口。",
    firmwareText: "固件",
    versionText: "版本",
    digestText: "摘要",
    sizeText: "大小",
    progressText: "进度：",
    firmwareInstallationCompleted: "固件安装完成",
    firmwareInstallationFailed: "固件安装失败",
    installationTimeoutFailed: "安装超时。请检查设备。",
  },
};

export const otaFirmwareInstallModalIt = {
  [pageNameKey]: {
    installingFirmwareText: "Installazione del firmware",
    installFirmwareOnDeviceText: "Installazione del firmware sul dispositivo",
    descriptionText:
      "Potrebbero essere necessari alcuni minuti. Non chiudere questa finestra durante l'installazione del firmware.",
    firmwareText: "Firmware",
    versionText: "Versione",
    digestText: "Hash",
    sizeText: "Dimensione",
    progressText: "Progresso:",
    firmwareInstallationCompleted: "Installazione del firmware completata",
    firmwareInstallationFailed: "Installazione del firmware non riuscita",
    installationTimeoutFailed:
      "C'è stato un timeout durante l'installazione. Controlla il dispositivo.",
  },
};

export const otaFirmwareInstallModalEs = {
  [pageNameKey]: {
    installingFirmwareText: "Instalando firmware",
    installFirmwareOnDeviceText: "Instalando firmware en el dispositivo",
    descriptionText:
      "Esto puede tardar unos minutos. No cierres esta ventana mientras la instalación del firmware está en curso.",
    firmwareText: "Firmware",
    versionText: "Versión",
    digestText: "Hash",
    sizeText: "Tamaño",
    progressText: "Progreso:",
    firmwareInstallationCompleted: "Instalación del firmware completada",
    firmwareInstallationFailed: "La instalación del firmware falló",
    installationTimeoutFailed:
      "Tiempo de espera de instalación agotado. Verifica el dispositivo.",
  },
};

export const otaFirmwareInstallModalNl = {
  [pageNameKey]: {
    descriptionText:
      "Dit kan enkele minuten duren. Sluit dit venster niet terwijl de firmware wordt geïnstalleerd.",
    digestText: "Controle-nummer",
    firmwareInstallationCompleted: "Firmware-installatie voltooid",
    firmwareInstallationFailed: "Firmware-installatie mislukt",
    firmwareText: "Firmware",
    installFirmwareOnDeviceText: "Firmware wordt op het apparaat geïnstalleerd",
    installationTimeoutFailed:
      "Time-out bij installatie. Controleer het apparaat.",
    installingFirmwareText: "Firmware wordt geïnstalleerd",
    progressText: "Voortgang:",
    sizeText: "Grootte",
    versionText: "Versie",
  },
};

export const otaFirmwareInstallModalTr = {
  [pageNameKey]: {
    descriptionText:
      "Bu birkaç dakika sürebilir. Firmware kurulumu devam ederken lütfen bu pencereyi kapatmayın.",
    digestText: "Özet",
    firmwareInstallationCompleted: "Firmware kurulumu tamamlandı",
    firmwareInstallationFailed: "Ürün yazılımı yüklemesi başarısız oldu",
    firmwareText: "Ürün yazılımı",
    installFirmwareOnDeviceText: "Firmware'in cihaza yüklenmesi",
    installationTimeoutFailed:
      "Kurulum zaman aşımı. Lütfen cihazı kontrol edin.",
    installingFirmwareText: "Ürün Yazılımının Yüklenmesi",
    progressText: "İlerlemek:",
    sizeText: "Boyut",
    versionText: "Sürüm",
  },
};
